import React from 'react';
import { observer } from 'mobx-react-lite';
import { partnersStore } from '@/stores/PartnersStore';
import './PartnerModal.css';

const DeleteConfirmModal: React.FC = observer(() => {
  const uuid = partnersStore.deletingUuid;
  if (!uuid) return null;

  const partner = partnersStore.serviceCenters.find((p) => p.uuid === uuid);
  const partnerName = partner?.name || 'этого партнера';

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      partnersStore.cancelDelete();
    }
  };

  return (
    <div className="delete-confirm-modal__overlay" onClick={handleOverlayClick}>
      <div className="delete-confirm-modal">
        <h3 className="delete-confirm-modal__title">Удалить партнера?</h3>
        <p className="delete-confirm-modal__text">
          Вы уверены, что хотите удалить «{partnerName}»? Это действие нельзя отменить.
        </p>
        <div className="delete-confirm-modal__actions">
          <button
            className="delete-confirm-modal__cancel"
            onClick={partnersStore.cancelDelete}
            type="button"
          >
            Отмена
          </button>
          <button
            className="delete-confirm-modal__confirm"
            onClick={() => partnersStore.deleteServiceCenter(uuid)}
            type="button"
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
});

export default DeleteConfirmModal;
